import createAPIRequestId from '../helpers/createAPIRequestId'
import hasTempId from '../helpers/hasTempId'
import store from '../store/index'
//---------------------
// edit character count
//---------------------
export default async function useEditCharacterCount(count, { preview = false } = {}) {
  console.log('-------------------------------------')
  console.log('IN useEditCharacterCount....')
  console.log('count:', count)
  //--------------
  // access store
  //--------------
  const this_store = store
  //--------------------
  // set api call parms
  //--------------------
  let parm_id = ''
  let parm_partialInd = false
  const hasPersistedId = count.id != null && count.id !== '' && !hasTempId(count.id)

  if (hasPersistedId) {
    parm_id = count.id
    parm_partialInd = count.action !== 'DELETE' ? true : false
  }
  //---------------------------------------------
  // declare request parms to create api request
  //--------------------------------------------
  let endpoint = 'api/v1/character-counts/'
  //
  let request_parms = {
    endpoint: preview ? endpoint + '?preview=true' : endpoint,
    partialInd: parm_partialInd,
    id: parm_id,
  }
  //---------------------------------------------------
  // where DELETE add indicator for create api request
  //---------------------------------------------------
  if (count.action === 'DELETE') {
    request_parms.deleteInd = true
  }
  //--------------------------
  // create api request by id
  //--------------------------
  let request = createAPIRequestId(request_parms)
  //---------------
  // set api parms
  //---------------
  let api_parms = {
    api_request: request,
    api_preview: preview,
  }
  //----------------------------------
  // include payload where not DELETE
  //----------------------------------
  if (count.action !== 'DELETE') {
    api_parms.payload = count.payload
  }
  console.log('api_parms = ', api_parms)
  //-------------------------------------------------------------------------
  // - return the dispatch Promise in all cases
  // - preview callers will await this and receive the response
  // - non-preview callers can ignore the returned Promise (fire-and-forget)
  //-------------------------------------------------------------------------
  return this_store
    .dispatch('characters/editCharacterCount', api_parms)
    .then((res) => {
      // optional: log preview response
      if (preview) console.log('useEditCharacterCount preview result:', res)
      return res
    })
    .catch((err) => {
      console.error('editCharacterCount error:', err)
      // rethrow so callers awaiting this will receive the rejection
      throw err
    })
}
